module.exports = __webpack_public_path__ + "static/media/icon-checkin.697c3e1a.png";